import { FC } from 'react';
import { IconButton } from 'ui/IconButton';
import { ArrowRightIcon } from 'components/icons/ArrowRightIcon';

export interface NextArrowButtonProps {
  disabled: boolean;
}
export const NextArrowButton: FC<NextArrowButtonProps> = ({
  disabled = false,
}) => {
  return (
    <IconButton
      disabled={disabled}
      type="submit"
      className="m-2 cursor-pointer rounded-[4px] p-2 text-blue hover:bg-light-gray disabled:text-gray-500"
    >
      <ArrowRightIcon className="h-6 w-6" />
    </IconButton>
  );
};
